// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const STROLLEROPEDIA_MORE_ARTICLES = "Zobraz dal\u0161\u00ed \u010dl\u00e1nky";
